// extracted by mini-css-extract-plugin
export default {"contentText":"unauthorizedContent_contentText__p3q4Z","contentTextBlock":"unauthorizedContent_contentTextBlock__8ov+t"};